/**
 * Require Vehicle line item property on Winter Package PDP before add to cart.
 */
(function () {
  function showError(root, msg) {
    const err = root.querySelector('.winter-package-vehicle-fields__error');
    if (err) {
      err.textContent = msg || '';
      err.style.display = msg ? 'block' : 'none';
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      const scope = form.closest('.product__info-container') || form.closest('product-info');
      const wrap = scope?.querySelector('.winter-package-vehicle-fields');
      if (!wrap) return;

      // Inputs use form="..." and live outside <form>; form.querySelector does not see them.
      const vehicle = (wrap.querySelector('input[name="properties[Vehicle]"]')?.value || '').trim();
      if (!vehicle) {
        e.preventDefault();
        e.stopPropagation();
        showError(wrap, 'Please enter your vehicle (year, make, model).');
        return;
      }
      showError(wrap, '');
    },
    true
  );

  document.addEventListener('input', function (e) {
    const wrap = e.target?.closest?.('.winter-package-vehicle-fields');
    if (wrap) showError(wrap, '');
  });
})();
